import { states } from '@/js/Objectives/ObjectiveFile';

import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import classes from './ObjectiveBar.module.css';
import star from '../../../images/star.png'
import Texts from 'react-sdk/Texts';
import AppState from '@/js/AppState';


const ObjectiveBar = () => {

  if (AppState.soloObjectives.activeRootObjectives.length === 0) return null

  var childrenObjs = AppState.soloObjectives.rootObjectives.reduce((acc, chapter) => {
    return [...acc, ...chapter.children
      .filter(objective => objective.state === states.ACTIVE || objective.state === states.COMPLETED)]
  }, [])


  return (
    <div className={classes.ObjectiveBar}>
      <div className={classes.title}>{Texts.get("objective-bar-title")}</div>
      {childrenObjs.map(objective =>
        <div key={objective.id} className={clsx(classes.Objective, classes[objective.state])}>
          <div className={ clsx(classes.objLine, classes[objective.state]) } > <div className={classes.obj_name}>{objective.name}</div></div>
          <div className={clsx(classes.subObjectiveList)}>
          {
            objective.children.flat().filter(objective => objective.state === states.ACTIVE || objective.state === states.COMPLETED).map(subObj => {
              return (
                <div key={subObj.id} className={clsx(classes.SubObjective, classes[subObj.state])}>
                  <div className={ clsx(classes.objLine, classes[subObj.state]) } > <div className={clsx(classes.obj_name, classes.subobj_name)}>{subObj.name}</div></div>
                </div>
                )
            })
          }
          </div>

        </div>
      )}


      {/* {AppState.soloObjectives.rootObjectives.map(chapter => {

        let children = chapter.children
        .filter(objective => objective.state === states.ACTIVE || objective.state === states.COMPLETED  )


        return (
        <div className={clsx(classes.Objective, classes[chapter.state])} key={chapter.id}>

        </div>
        )

      }) } */}
    </div>
  );
};

export default observer(ObjectiveBar)
